export default __webpack_public_path__ + "static/media/login_bank.b7b85a21.svg";